import { render, staticRenderFns } from "./EventiEditComponent.vue?vue&type=template&id=38a64bd8"
import script from "./EventiEditComponent.vue?vue&type=script&lang=js"
export * from "./EventiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports